import React from 'react';
import { createUseStyles } from 'react-jss';
import classNames from 'classnames';
import P from '../atoms/P';
const getStyles = createUseStyles({
    '@keyframes fadeIn': {
        from: { opacity: 0 },
        to: { opacity: 1 },
    },
    root: {
        lineHeight: '2rem',
        marginTop: 8,
        paddingLeft: 24,
        position: 'relative',
        animationName: '$fadeIn',
        animationDuration: 0.5
    },
    icon: {
        position: 'absolute',
        left: 0,
        display: 'inline-block',
        fontSize: '1.4rem',
    },
    error: {
        color: '#E0032A',
    },
    warning: {
        color: '#FFB100',
    },
    success: {
        color: '#00AF00',
    },
});
const emoji = {
    error: '⛔',
    warning: '⚠️',
    success: '✅',
};
const Feedback = ({ children, type }) => {
    const styles = getStyles();
    return (React.createElement(P, { className: classNames(styles.root, styles[type]), weight: "regular" },
        React.createElement("span", { className: classNames(styles.icon) }, emoji[type]),
        children));
};
export default Feedback;
//# sourceMappingURL=Feedback.js.map